/**
 * AudioMessage Component
 *
 * Renders audio chat messages with native HTML5 audio player.
 * Supports reply context.
 */

import React, { FC } from "react"
import clsx from "clsx"
import ChatMessageReplyView from "src/app/layout/chat-handle/components/chat-replymessage/ChatMessageReplyView"
import { AudioMessageProps } from "../../types/MessageTypes"

const AudioMessage: FC<AudioMessageProps> = ({
  message,
  bgChat,
  txChat,
  isTabletOrMobile,
  replyMessageID,
  customer,
  phoneNumber,
}) => {
  const maxWidthClass = isTabletOrMobile ? "mw-250px" : "mw-300px"

  /**
   * Renders the audio player
   */
  const renderAudio = () => (
    <div
      className={clsx("rounded p-2", bgChat, maxWidthClass)}
      style={{ minWidth: "200px" }}
    >
      <audio controls className="w-100" style={{ maxWidth: "280px" }}>
        <source src={message.mediaUrl} type="audio/mpeg" />
        <source src={message.mediaUrl} type="audio/ogg" />
        <source src={message.mediaUrl} type="audio/aac" />
        Your browser does not support the audio element.
      </audio>
    </div>
  )

  /**
   * Renders with reply context
   */
  const renderWithReply = () => (
    <ChatMessageReplyView
      bgChat={bgChat}
      replyMessageID={replyMessageID}
      customer={customer}
      phoneNumber={phoneNumber}
    >
      {renderAudio()}
    </ChatMessageReplyView>
  )

  // Render with or without reply context
  if (message.replyMessageID) {
    return renderWithReply()
  }

  return renderAudio()
}

export default AudioMessage
